<div class="card">
    <div class="card-header">
      <div class="d-flex">
        <h4 class="me-2 mb-0">Delete Application?</h4>
        <!-- <mat-icon color="accent" title="Help" class="question-tooltip cursor-pointer"
          (click)="util.openMsgDialog(helpText)">help_outline</mat-icon> -->
      </div>
  
    </div>
    <div class="card-body">
      <form [formGroup]="interalForm">
        <p>
          This action cannot be undone. 
          Please select a reason for deleting this application from the options below. 
          If none apply, you may enter your own reason in the text field provided.
        </p>
        <div class="row form-group">
          <mat-radio-group aria-label="Select an option" class="example-radio-group d-flex flex-column mb-2" formControlName="deleteReason" (change)="changeValidation()">
            <mat-radio-button *ngFor="let option of options" [value]="option">{{option}}</mat-radio-button>
          </mat-radio-group>
        </div>
        <app-form-control type="textarea" [form]="interalForm" title="Specify Delete Reason" placeholder="Specify Delete Reason"
          controlName="deleteComment" *ngIf="!interalForm.get('deleteComment')?.disabled"></app-form-control>
      </form>
    </div>
  </div>
  
  <!-- {{interalForm.value | json}} -->
  
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-button [disabled]="interalForm.invalid" (click)="requestApplicationDelete()">Submit</button>
  </mat-dialog-actions>